import { useIsMobile } from 'src/utils'
import EmptyState from '../EmptyState/EmptyState'
import { useNavigate } from 'react-router-dom'
import { Left } from 'src/assets'
import { t } from 'i18next'

const UnderConstructions = () => {
  const isMobile = useIsMobile()
  const navigate = useNavigate()

  return (
    <EmptyState
      {...{
        className: `${isMobile ? '!h-fit' : ''}`,
        title: t('global.page.under.construction'),
        subtitle: t('global.page.under.construction.subtitle'),
        icon: <div className='inset-0 flex-center text-5xl'>404</div>,
        buttonText: t('global.go.to.dashboard'),
        buttonIcon: <Left />,
        onClick: () => navigate('/'),
      }}
    />
  )
}

export default UnderConstructions
